<template>
  <div class="bottomcontact">
    <div class="inner">
      <h4>
        <span>プラン作成、設計、土地のご紹介、</span>
        <span>すべてお手伝いいたします</span>
      </h4>
      <p>
        長井商事株式会社は、大型施設・住宅の建設から、リフォームまで、暮らしにまつわるあらゆる事業を展開しております。
        <br />
        新築・リフォームなど、住宅についてのご相談は、お気軽に天草営業所までお問い合わせください。
      </p>
      <div class="bg">
        <img src="@/assets/images/common/a_topimg.jpg" alt="お問い合わせ" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bottomcontact {
  padding: 0 $h-gap;
  margin-top: $v-gap;
  margin-bottom: $v-gap;
  .inner {
    position: relative;
    margin: 0 auto;
    padding: $h-gap;
    overflow: hidden;
    display: flex;
    border-radius: calc($h-gap / 2);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    @include tb {
      padding: $v-gap $h-gap;
    }
    h4 {
      max-width: 640px;
      margin: 0 auto;
      font-weight: bold;
      font-size: clamp(1.8rem, 1.8vw, 2rem);
      text-align: center;
      margin-bottom: 1.5rem;
      line-height: 1.5;
      span {
        display: inline-block;
      }
    }
    p {
      max-width: 640px;
      margin: 0 auto;
      line-height: 1.5;
      margin-bottom: 1.5rem;
    }
    a {
      display: inline-block;
      background-color: $color_blue;
      color: white;
      margin: 0 auto;
      font-weight: bold;
      padding: 1em 4em;
      text-align: center;
      min-width: 240px;
      border-radius: 0.4rem;
      transition: 0.25s;
      &:hover {
        background-color: $color_lblue;
        color: $color_blue;
      }
    }
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: -1;
      opacity: 0.2;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
